import React from 'react';
import SafeIcon from '../common/SafeIcon';

const MyCertificates = () => {
  const CERTS = [
    { name: 'BOSIET Survival', issued: 'Jan 2023', expiry: 'Jan 2027', status: 'Valid', type: 'Mandatory' },
    { name: 'STCW Basic Safety', issued: 'Mar 2022', expiry: 'Mar 2027', status: 'Valid', type: 'Mandatory' },
    { name: 'GMA Medical Fitness', issued: 'May 2024', expiry: 'May 2025', status: 'Warning', type: 'Medical' },
  ];

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">My Mandatory Certificates</h1>
          <p className="text-gray-500 text-sm">Track your seafarer and safety certifications.</p>
        </div>
        <button className="bg-[#11469A] text-white px-4 py-2.5 rounded-lg font-bold text-sm flex items-center gap-2 shadow-sm">
          <SafeIcon name="Upload" size={18} /> Upload New
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {CERTS.map(cert => (
          <div key={cert.name} className="card p-6 border border-gray-100">
            <div className="flex justify-between items-start mb-4">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                cert.status === 'Valid' ? 'bg-green-50 text-green-600' : 'bg-yellow-50 text-yellow-600'
              }`}>
                <SafeIcon name="Award" size={20} />
              </div>
              <span className={`text-[10px] font-bold uppercase tracking-widest px-2 py-1 rounded ${
                cert.status === 'Valid' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'
              }`}>{cert.status}</span>
            </div>
            <h3 className="font-bold text-gray-800 mb-1">{cert.name}</h3>
            <p className="text-xs text-gray-400 font-bold uppercase tracking-wider mb-4">{cert.type}</p>
            <div className="space-y-2 text-xs">
              <div className="flex justify-between"><span className="text-gray-500">Issued On:</span><span className="font-bold text-gray-700">{cert.issued}</span></div>
              <div className="flex justify-between"><span className="text-gray-500">Expires On:</span><span className="font-bold text-red-500">{cert.expiry}</span></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyCertificates;